const moment = require('moment');

angular
  .module('washesDashboard')
  .component('washesDashboard', {
    template: require('./washes-dashboard.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function WashesDashBoardController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'washes';
        $rootScope.menu = 'washesDashboard';
        this.selectedEmployeeId = '-1';
        this.selectedAreaId = '-1';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        $scope.fetchData = () => {
          $resource(`${APIURL}/admin/washes/dashboard`).get({}, (data) => {
            this.target_date = moment().format('YYYY-MM-DD');
            this.response = data;
            this.selectedCarType = data.defaultGroupGoodsId.toString();
            this.selectedGoodsId = data.defaultGoods.ID.toString();
            this.selectedDuration = data.defaultGoods.DURATION;
            $scope.processEmployees(data.data.employees);
            console.log(data.data);
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        $scope.displayInstantAreas = () => {
          if (!this.response) {
            return '-';
          }
          const areaNames = this.response.data.instant.areas.map(area => area.NAME);
          return areaNames.join(',');
        };
        $scope.displayReserveAreas = () => {
          if (!this.response) {
            return '-';
          }
          const areaNames = this.response.data.reserve.areas.map(area => area.NAME);
          return areaNames.join(',');
        };
        $scope.onChangeGoods = () => {
          const selectedGoods = this.response.goods.filter(goods => goods.ID == this.selectedGoodsId); // eslint-disable-line eqeqeq
          if (selectedGoods.length < 1) {
            return;
          }
          this.selectedDuration = selectedGoods[0].DURATION;
          $resource(`${APIURL}/admin/goods/options/goodsId/${this.selectedGoodsId}`).get((data) => {
            this.response.options = data.options;
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        $scope.onChangeOption = (option) => {
          console.log(option);
          if (option.checked) {
            this.selectedDuration = this.selectedDuration + option.DURATION;
          } else {
            this.selectedDuration = this.selectedDuration - option.DURATION;
          }
        };
        $scope.onChangeCarType = () => {
          $resource(`${APIURL}/admin/goods/groupGoodsId/${this.selectedCarType}`).get((data) => {
            this.response.goods = data.goods;
            this.selectedGoodsId = data.goods[0].ID.toString();
            $scope.onChangeGoods();
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        $scope.updateToday = () => {
          $resource(`${APIURL}/admin/washes/dashboard/today`).get({ duration: this.selectedDuration }, (data) => {
            this.response.activeEmployeesCount = data.activeEmployeesCount;
            this.response.totalActiveEmployeesCount = data.totalActiveEmployeesCount;
            this.response.data.instant = data.instant;
            this.response.data.reserve = data.reserve;
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        $scope.updateEmployees = () => {
          $resource(`${APIURL}/admin/washes/dashboard/employees`).get({ duration: this.selectedDuration, targetDate: this.target_date }, (data) => {
            this.response.data.employees = data.employees;
            $scope.processEmployees(data.employees);
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        $scope.onDatePick = () => {
          this.target_date = jQuery('#inputPicker').val();
        };
        $scope.movePrevDate = () => {
          const prevMoment = moment(this.target_date, 'YYYY-MM-DD').add(-1, 'days');
          this.target_date = prevMoment.format('YYYY-MM-DD');
        };
        $scope.moveNextDate = () => {
          const prevMoment = moment(this.target_date, 'YYYY-MM-DD').add(1, 'days');
          this.target_date = prevMoment.format('YYYY-MM-DD');
        };
        $scope.processEmployees = (employees) => {
          this.employees = employees.map((employee) => {
            if (employee.AVAILABLES && employee.AVAILABLES.length > 0 && employee.AVAILABLES[0].DIRECT) {
              employee.DIRECT_AVAILABLE = employee.AVAILABLES[0];
            }
            if (Array.isArray(employee.ORDERS)) {
              employee.ORDERS = employee.ORDERS.sort((a, b) => a.START > b.START);
            }
            if (Array.isArray(employee.HOLIDAYS)) {
              employee.HOLIDAYS = employee.HOLIDAYS.sort((a, b) => a.START > b.START);
            }
            return employee;
          });
          this.employees = this.employees.filter((employee) => {
            if (this.selectedEmployeeId !== '-1' && this.selectedEmployeeId !== employee.ID.toString()) {
              return false;
            }
            if (this.selectedAreaId !== '-1') {
              const selected = employee.TB_AREA_IDS.split(',').filter(item => item === this.selectedAreaId);
              return selected.length > 0;
            }
            return true;
          });
        };
        $scope.fetchData();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/washes-dashboard/washes-dashboard.component.js